export const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Homepage.vue'),
    meta: {
      title: 'Главная страница',
      layout: 'homepage-layout',
      publicOnly: true,
    },
  },
  {
    path: '/list-enrollments',
    name: 'ListEnrollments',
    component: () => import('@/modules/PaymentSystem/pages/EnrollmentList.vue'),
    meta: {
      title: 'Списки зачисления',
      authorize: [],
    },
  },
  {
    path: '/diplomas/qr/:hash',
    name: 'DiplomaQr',
    component: () => import('@/modules/PaymentSystem/pages/QR.vue'),
    meta: {
      title: 'QR',
      layout: 'empty-layout',
    },
  },
  {
    path: '/desktop',
    name: 'Desktop',
    component: () => import('../views/Desktop.vue'),
    meta: {
      authorize: [],
      breadcrumbs: {
        show: false,
      },
    },
  },
  {
    path: '/contacts',
    name: 'Contacts',
    component: () => import('../views/Contacts.vue'),
    meta: {
      title: 'Контакты',
      authorize: [],
    },
  },
  {
    path: '/teachers',
    name: 'TeacherList',
    component: () => import('../modules/Teachers/pages/TeacherList.vue'),
    meta: {
      title: 'Преподаватели',
      authorize: [],
    },
  },
  {
    path: '/directions',
    name: 'Directions',
    component: () => import('../views/Directions.vue'),
    meta: {
      title: 'Направленности',
      // authorize: [],
    },
  },
  {
    path: '/authorization',
    name: 'Authorize',
    component: () => import('../modules/Auth/pages/AuthorizeOutside.vue'),
    meta: {
      title: 'Внешняя авторизация',
      // authorize: [],
    },
  },
  {
    path: '/authorization/second-step',
    name: 'AuthorizeSecond',
    component: () => import('../modules/Auth/pages/AuthorizeSecond.vue'),
    meta: {
      title: 'Второй шаг авторизации',
      // authorize: [],
    },
  },
  {
    path: '/sign-in',
    name: 'SignIn',
    component: () => import('../modules/Auth/pages/LoginPage.vue'),
    meta: {
      title: '',
      publicOnly: true,
      // authorize: [],
    },
  },
  {
    path: '/sign-up',
    name: 'SignUp',
    component: () => import('../modules/Auth/pages/SignUpPage.vue'),
    meta: {
      publicOnly: true,
      title: 'Регистрация',
    },
  },
  {
    path: '/user-profile',
    name: 'UserProfile',
    component: () => import('../views/UserProfile.vue'),
    meta: {
      title: 'Профиль пользователя',
      authorize: [],
    },
  },
  {
    path: '/common-course-settings',
    name: 'CourseCommonSettings',
    component: () => import('../views/CourseCommonSettings.vue'),
    meta: {
      title: 'Настройки курсов',
      authorize: [],
    },
  },
  {
    path: '/testpage',
    name: 'Testpage',
    component: () => import('../views/Testpage.vue'),
    meta: {
      title: 'Testpage',
      // authorize: [],
    },
  },
  {
    path: '/payment-feedback',
    name: 'PaymentFeedback',
    component: () => import('../views/PaymentFeedback.vue'),
    meta: {
      title: 'Статус платежа',
    },
  },
  {
    path: '/verify-email',
    name: 'verifyEmail',
    component: () => import('../views/UserVerifyEmail.vue'),
    meta: {
      authorize: [],
    },
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: () => import('../views/ResetPassword.vue'),
    meta: {
      // authorize: [],
    },
  },
  {
    path: '/verify',
    name: 'TelegramVerify',
    component: () => import('../modules/Auth/pages/AuthorizeTelegram.vue'),
    meta: {
      publicOnly: true,
      title: 'Регистрация',
      layout: 'empty-layout',
    },
  },
  {
    path: '/instructions',
    name: 'Instructions',
    component: () => import('../modules/Instructions/pages/Instructions.vue'),
    meta: {
      title: 'Инструкции',
    },
  },
  { path: '*', redirect: '/' },

  {
    path: '/notifications',
    name: 'Notifications',
    component: () => import('../views/TheNotifications.vue'),
    meta: {
      authorize: [],
    },
  },
];

export default routes;
